import '../assets/NcButton-DbE0wInI.css';
import { defineComponent, computed, inject, toRef, createBlock, openBlock, resolveDynamicComponent, mergeProps, withCtx, createElementVNode, renderSlot, createTextVNode, toDisplayString } from "vue";
import { useLink, routerKey } from "vue-router";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1 = { class: "button-vue__wrapper" };
const _hoisted_2 = { class: "button-vue__icon" };
const _hoisted_3 = { class: "button-vue__text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcButton",
  props: {
    alignment: { default: "center" },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean },
    download: { type: [String, Boolean], default: void 0 },
    href: { default: void 0 },
    pressed: { type: Boolean, default: void 0 },
    size: { default: "normal" },
    target: { default: "_self" },
    text: { default: void 0 },
    to: { default: void 0 },
    type: { default: "button" },
    variant: { default: "secondary" },
    wide: { type: Boolean }
  },
  emits: ["click", "update:pressed"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const routerLink = computed(() => inject(routerKey, null) !== null && props.to ? useLink({ to: toRef(() => props.to) }) : void 0);
    const isLink = computed(() => props.href);
    const hasPressedState = computed(() => !isLink.value && typeof props.pressed === "boolean");
    const realVariant = computed(() => {
      if (props.pressed) {
        return "primary";
      }
      if (props.pressed === false && props.variant === "primary") {
        return "secondary";
      }
      return props.variant;
    });
    const flexAlignment = computed(() => props.alignment.split("-")[0]);
    const isReverseAligned = computed(() => props.alignment.includes("-"));
    const getNcPopoverTriggerAttrs = inject("NcPopover:trigger:attrs", () => ({}), false);
    const ncPopoverTriggerAttrs = computed(() => getNcPopoverTriggerAttrs());
    const linkAttrs = computed(() => ({
      role: "button",
      href: props.href || "#",
      target: props.target,
      rel: "nofollow noreferrer noopener",
      download: props.download || null
    }));
    const buttonAttrs = computed(() => ({
      "aria-pressed": hasPressedState.value ? String(props.pressed) : void 0,
      type: props.type
    }));
    function onClick(event) {
      if (hasPressedState.value) {
        emit("update:pressed", !props.pressed);
      }
      emit("click", event);
      routerLink.value?.navigate(event);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(isLink.value ? "a" : "button"), mergeProps({
        class: ["button-vue", [
          `button-vue--size-${_ctx.size}`,
          {
            [`button-vue--${realVariant.value}`]: realVariant.value,
            "button-vue--wide": _ctx.wide,
            [`button-vue--${flexAlignment.value}`]: flexAlignment.value !== "center",
            "button-vue--reverse": isReverseAligned.value,
            active: routerLink.value?.isActive
          }
        ]],
        disabled: _ctx.disabled,
        "aria-label": _ctx.ariaLabel
      }, {
        ...ncPopoverTriggerAttrs.value,
        ...isLink.value ? linkAttrs.value : buttonAttrs.value
      }, { onClick }), {
        default: withCtx(() => [
          createElementVNode("span", _hoisted_1, [
            createElementVNode("span", _hoisted_2, [
              renderSlot(_ctx.$slots, "icon", {}, void 0, true)
            ]),
            createElementVNode("span", _hoisted_3, [
              renderSlot(_ctx.$slots, "default", {}, () => [
                createTextVNode(toDisplayString(_ctx.text), 1)
              ], true)
            ])
          ])
        ]),
        _: 3
      }, 16, ["class", "disabled", "aria-label"]);
    };
  }
});
const NcButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0cc855a4"]]);
export {
  NcButton as N
};
//# sourceMappingURL=NcButton-Byg8-ta1.mjs.map
